import {createSlice} from '@reduxjs/toolkit';
import {httpDelete, httpPost} from '../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../constants/MicroServiceConstants';
import {CONTACT_TYPE, STATE} from '../../../constants/Lookup';
const initialData = {
  clientContactData: {},
  dropDownData: {},
  clientContactStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  duplicateParentMsg: null,
  parentPostAddStatus: null,
  parentClientID: null,
};

const slice = createSlice({
  name: 'clientContact',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postClientContactData: (state, action) => {
      state.clientContactStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    postParentData: (state, action) => {
      if (
        action?.payload?.data?.status === 400 &&
        action?.payload?.data?.message === 'Parent name alread exist'
      ) {
        state.duplicateParentMsg = action.payload.data.message;
      }
      state.clientContactStatus = action.payload.status;
      state.parentPostAddStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = 'Parent Client added Successfully';
      state.parentClientID = action.payload.response;
    },
    putClientContactData: (state, action) => {
      state.clientContactStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    deleteClientContactData: (state, action) => {
      state.clientContactStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetClientContact: (state) => {
      state.clientContactStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.parentPostAddStatus = null;
      state.clientContactStatus = null;
    },
    resetduplicateParentMsg: (state) => {
      state.duplicateParentMsg = null;
      state.parentPostAddStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchDropDownData,
  resetMsg,
  postClientContactData,
  postParentData,
  putClientContactData,
  fetchStart,
  resetClientContact,
  deleteClientContactData,
  fetchError,
  resetduplicateParentMsg,
} = slice.actions;

export const fetchDropDowns = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [STATE, CONTACT_TYPE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postClientContact = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/contact`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postClientContactData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postParentContact = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/parentclientDetails`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postParentData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const putClientContact = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/update/contact`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(putClientContactData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const deleteClientContact = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpDelete(`${CLIENT_MAINTENANCE}/delete/contact/${details}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(deleteClientContactData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetClientContact());
  };
};
export const resetParentClientStatus = () => {
  return (dispatch) => {
    dispatch(resetClientContact());
  };
};
export const resetduplicateParentMessage = () => {
  return (dispatch) => {
    dispatch(resetduplicateParentMsg());
  };
};
